var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class AsyncQueue {
    constructor() {
        this.queue = [];
        this.isRunning = false;
    }
    enqueue(task) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                this.queue.push(() => __awaiter(this, void 0, void 0, function* () {
                    try {
                        const result = yield task();
                        resolve(result);
                    }
                    catch (error) {
                        reject(error);
                    }
                }));
                if (!this.isRunning) {
                    this.isRunning = true;
                    void this.run();
                }
            });
        });
    }
    run() {
        return __awaiter(this, void 0, void 0, function* () {
            while (this.queue.length > 0) {
                const task = this.queue.shift();
                if (task) {
                    yield task();
                }
            }
            this.isRunning = false;
        });
    }
}
